import httpUtils from '../../utils/HttpUtils'

class ProjectCustomerVoucherService {
  async save ({ projectId, image}) {
    var result = null;
    try {
      result = await httpUtils.post('/server/project/customer/voucher/save',{ projectId, image});
    } catch (e) {
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
  async remove ({ id }) {
    var result = null;
    try {
      result = await httpUtils.post('/server/project/customer/voucher/remove',{ id });
    } catch (e) {
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new ProjectCustomerVoucherService()
